// UI imports
import React from 'react'
// Navigation imports
import { Link, useLocation } from 'react-router-dom'

// Auth imports
import { auth } from '../firebase'

import { RiHomeLine } from 'react-icons/ri'
import { BsJournalBookmark } from 'react-icons/bs'
import { BsJournalPlus } from 'react-icons/bs'
import { BsCalendar4 } from 'react-icons/bs'
import { BiUserCircle } from 'react-icons/bi'

function Header(props: any) {
  const location = useLocation()

  const username = auth.currentUser?.email?.split('@')[0]

  return (
    <div className="flex h-full flex-row rounded-tr-lg rounded-br-lg bg-primary">
      {/* darker purple bar */}
      <div className="h-full w-2 rounded-tr-lg rounded-br-lg bg-secondary sm:w-8"></div>

      {/* Left Side */}
      <div className="flex flex-col items-center px-1 py-4">
        {/* logo */}
        <img
          alt="peacemind logo"
          className="border-1 my-3 hidden w-4/6 rounded-lg px-4 py-2 sm:flex"
          src="/img/logo2.png"
        />

        {/* login User Name */}
        <div className={auth.currentUser ? '' : 'hidden'}>
          {/* sm username */}
          <div className="mx-auto flex h-8 w-8 items-center justify-center rounded-3xl bg-tertiary font-body uppercase text-white sm:hidden">
            {username?.charAt(0)}
          </div>
          {/* full username */}
          <div className="mx-auto hidden h-10 w-32 items-center justify-center rounded-3xl bg-tertiary font-body text-white sm:flex">
            {username}
          </div>
        </div>

        {/* Menu */}
        <div className="mt-4 flex h-96 flex-col sm:w-5/6">
          <Link
            className={`mb-3 flex w-full rounded-2xl px-2 py-2 font-body sm:px-4 ${
              location.pathname === '/home' ? 'bg-white' : ''
            } hover:bg-secondary hover:text-white`}
            to="/home"
          >
            <RiHomeLine size={20} />
            <div className="ml-2 hidden sm:flex">Home</div>
          </Link>

          <Link
            className={`mb-3 flex w-full rounded-2xl px-2 py-2 font-body sm:px-4 ${
              location.pathname === '/journals' ? 'bg-white' : ''
            } hover:bg-secondary hover:text-white`}
            to="/journals"
          >
            <BsJournalBookmark size={20} />
            <div className="ml-2 hidden sm:flex">My Journals</div>
          </Link>

          <Link
            to="/new_journal"
            className={`mb-3 flex w-full rounded-2xl px-2 py-2 font-body sm:px-4 ${
              location.pathname.includes('/new_journal') ? 'bg-white' : ''
            } hover:bg-secondary hover:text-white`}
          >
            <BsJournalPlus size={20} />
            <div className="ml-2 hidden sm:flex">New Journal</div>
          </Link>

          <Link
            to="/calendar"
            className={`mb-3 flex w-full rounded-2xl px-2 py-2 font-body sm:px-4  ${
              location.pathname === '/calendar' ? 'bg-white' : ''
            } hover:bg-secondary hover:text-white`}
          >
            <BsCalendar4 size={20} />
            <div className="ml-2 hidden sm:flex">Calendar</div>
          </Link>

          <Link
            to="/profile"
            className={`mb-3 flex w-full rounded-2xl px-2 py-2 font-body sm:px-4  ${
              location.pathname === '/profile' ? 'bg-white' : ''
            } hover:bg-secondary hover:text-white`}
          >
            <BiUserCircle size={20} />
            <div className="ml-2 hidden sm:flex">User Profile</div>
          </Link>
        </div>
      </div>
    </div>
  )
}

export default Header
